// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'

import router from './router'
import store from './store'
import i18n from './i18n'
import './register-service-worker'
import NotificationManager from '@/services/notifications-manager'
import './components'

import { AxiosPlugin } from './plugins/axios'

import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'
import colors from 'vuetify/es5/util/colors'
import CrispChat from '@dansmaculotte/vue-crisp-chat'

// icons globally
import Icon from '@/components/icons/Icons.vue'
Vue.component('Icon', Icon)

// vue portal
import PortalVue from 'portal-vue'
Vue.use(PortalVue)

Vue.use(Vuetify, {
  iconfont: 'md',
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  },
  theme: {
    primary: '#4eba6f',
    secondary: colors.blue.lighten2,
    success: '#3cd1c2',
    info: '#ffaa2c',
    error: '#f83e70'
  }
})

Vue.use(AxiosPlugin, { baseURL: process.env.VUE_APP_API_URL })

Vue.config.productionTip = false

var crispId =
  process.env.NODE_ENV === 'development'
    ? '407b9ed4-8ff4-4cdd-b379-36030cd7be63'
    : 'd9fda91f-4dcf-4088-9446-ca072de6d935'
Vue.use(CrispChat, {
  websiteId: crispId,
  disabled: false,
  hideOnLoad: false
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: { App },
  render: h => h(App),
  created() {
    NotificationManager.subscribe(this.$store)
  }
}).$mount('#app')
